import {
  BotButtonPayloadType,
  IBotButtonsResponseData,
  ICommandPayload,
  IOpenUrlPayload,
  IShareCardPayload,
} from '@gem/models/botModel';
import { IGraphicSize } from '@gem/models/commonModel';
import { t } from '@gem/modules/i18n';

import { PayloadType } from 'APP/model/message/messageModel.types';
import type { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

import { Payload } from '../Payload';
import { CommandButtonPayload } from './CommandButtonPayload';
import { OpenUrlButtonPayload } from './OpenUrlButtonPayload';
import { ShareCardButtonPayload } from './ShareCardButtonPayload';

export interface IButtonPayloadModel {
  payload: ShareCardButtonPayload | OpenUrlButtonPayload | CommandButtonPayload | null;
  id: string;
  title: string;
}

export class ButtonsPayload extends Payload {
  text: string;
  buttons: IButtonPayloadModel[];
  layout: string[];
  imageUrl?: string;
  graphicSize?: IGraphicSize;

  constructor(data: IBotButtonsResponseData & { message: ChatMessage }) {
    super({ ...data, payloadType: PayloadType.Buttons });

    this.text = data.text;
    this.imageUrl = data.imageUrl;
    this.graphicSize = data.graphicSize;

    this.buttons = data.buttons.map((button) => {
      let payload = null;
      switch (button.payload?.type) {
        case BotButtonPayloadType.ShareCard: {
          payload = new ShareCardButtonPayload(button.payload as IShareCardPayload);
          break;
        }
        case BotButtonPayloadType.OpenUrl: {
          payload = new OpenUrlButtonPayload(button.payload as IOpenUrlPayload);
          break;
        }
        case BotButtonPayloadType.Command: {
          payload = new CommandButtonPayload(button.payload as ICommandPayload);
          break;
        }
      }

      return { ...button, payload };
    });
    this.layout = data.layout;
  }

  get typeDescription(): string {
    return t('bot_message');
  }

  toJSON(): IBotButtonsResponseData {
    return {
      ...super.toJSON(),
      text: this.text,
      buttons: this.buttons.map((button) => ({
        id: button.id,
        title: button.title,
        payload: button.payload?.toJSON(),
      })),
      layout: this.layout,
      imageUrl: this.imageUrl,
      graphicSize: this.graphicSize,
    };
  }
}
